import { FETCH_STORE_SYLLABUS_VALUES } from '@cont/Batch/utils';
import useFetch from '@hooks/useFetch';

export const getKey = ({ batchUID }) =>
  `v1/batch/${batchUID}/completed_tests/?limit=${FETCH_STORE_SYLLABUS_VALUES.LIMIT}&offset=${FETCH_STORE_SYLLABUS_VALUES.OFFSET}`;

const useStorePlaylistTestFeed = ({ batchUID }) => {
  const key = getKey({ batchUID });
  const { data: storePlaylistTestFeed, ...rest } = useFetch(key);

  return {
    key,
    storePlaylistTestFeed,
    ...rest
  };
};

export default useStorePlaylistTestFeed;
